import script from "./CoursesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursesView.vue?vue&type=script&setup=true&lang=js"

import "./CoursesView.vue?vue&type=style&index=0&id=0956af18&scoped=true&lang=css"

import exportComponent from "/home/reppard/Sync/work/src/git.habbnn.com/bitbrain-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0956af18"]])

export default __exports__